import { base64ToBlob } from "./base64ToBlob";

export const openBase64 = (
  base64: string,
  type: string,
  filename: string,
  convert: boolean = true,
  returnUrl: boolean = false,
) => {
  const isPdf = type === "pdf";
  let url;
  if (convert) {
    const blob = base64ToBlob(
      base64,
      isPdf ? "application/pdf" : `image/${type}`,
    );

    url = URL.createObjectURL(blob);
  } else {
    url = base64;
  }
  if (returnUrl) return url;
  const w = window.open("", "modal" + Date.now());

  w?.document.write(
    `<html><head><meta name="viewport" content="width=device-width, initial-scale=1" /><title>${filename}</title></head><iframe style="position:fixed; top:0; left:0; bottom:0; right:0; width:100%; height:100%; border:none; margin:0; padding:0; overflow:hidden; z-index:999999;" src="${url}"></iframe></html>`,
  );
};
